import type { AvatarProps } from '@findigs/ui-kit/src/components/avatar';
import { Avatar } from '@findigs/ui-kit/src/components/avatar';
import { Button } from '@findigs/ui-kit/src/components/button';
import { Link as RemixLink } from '@remix-run/react';
import { styles } from './navbar-profile-card.module.scss';

export type NavbarProfileCardProps = Omit<AvatarProps, 'variant'> & {
  email: string;
  onLinkClicked?: () => void;
};

export const NavbarProfileCard = ({
  firstName,
  lastName,
  email,
  className,
  onLinkClicked,
  ...props
}: NavbarProfileCardProps) => {
  const classes = [styles, className].filter((c) => c).join(' ');
  return (
    <div {...props} className={classes}>
      <div className="main">
        <div>
          <Avatar
            className="avatar"
            firstName={firstName}
            lastName={lastName}
            variant="Person"
          />
        </div>
        <div className="user-details">
          <p className="name" title={`${firstName} ${lastName}`}>
            {firstName} {lastName}
          </p>
          <p className="email text-b-sm-regular" title={email}>
            {email}
          </p>
        </div>
      </div>
      <div className="buttons">
        <Button
          variant="Outlined"
          as={RemixLink}
          to="/profile"
          onClick={onLinkClicked}
        >
          Manage profile
        </Button>
        <Button
          variant="Text"
          as={RemixLink}
          to="/logout"
          onClick={onLinkClicked}
        >
          Log out
        </Button>
      </div>
    </div>
  );
};
